// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"5777a5e1","156":"486c5815","278":"3a28469c","351":"53d073d9","363":"c7efdd43","558":"0b669df4","711":"62a776ce"}[chunkId] + ".chunk.js";
};